(() => {
  const init = (root) => {
    if (!root || root.dataset.caseledReady === 'true') return;
    root.dataset.caseledReady = 'true';

    const buttons = Array.from(root.querySelectorAll('[data-caseled-color]'));
    const currentLabel = root.querySelector('[data-caseled-current-color]');
    const modal = root.querySelector('[data-caseled-modal]');
    const modalPanel = root.querySelector('[data-caseled-modal-panel]');
    const modalChoice = root.querySelector('[data-caseled-modal-choice]');
    const formSlot = root.querySelector('[data-caseled-form-slot]');
    const orderButtons = Array.from(root.querySelectorAll('[data-caseled-order-cta]'));
    let lastFocused = null;
    let previousOverflow = '';
    let observer = null;
    let timer = null;

    const selected = () => buttons.find((button) => button.getAttribute('aria-pressed') === 'true') || buttons[0];

    const updateLabelAndImage = () => {
      const choice = selected();
      if (!choice) return;
      const label = choice.dataset.caseledLabel || 'وردي';
      const message = 'اللون المختار: ' + label + ' — 189 درهم.';
      if (currentLabel) currentLabel.textContent = message;
      if (modalChoice) modalChoice.textContent = message;
      const image = root.querySelector('[data-caseled-main-image]');
      const imageUrl = choice.dataset.caseledImage || (
        choice.dataset.caseledColor === 'Noir'
          ? 'https://cdn.shopify.com/s/files/1/0971/8785/6691/files/organisateur-maquillage-miroir-led-noir.jpg?v=1792511137'
          : 'https://cdn.shopify.com/s/files/1/0971/8785/6691/files/organisateur-maquillage-miroir-led-rose.webp?v=1792511129'
      );
      if (image && imageUrl) {
        image.removeAttribute('srcset');
        image.setAttribute('src', imageUrl);
        image.src = imageUrl;
        image.alt = choice.dataset.caseledImageAlt || label;
        image.dataset.caseledCurrentColor = choice.dataset.caseledColor || '';
      }
    };

    const syncVariant = (button) => {
      const variantId = button && button.dataset.caseledVariantId;
      if (!variantId) return;
      const picker = document.querySelector('variant-picker input[data-variant-id="' + variantId + '"]');
      if (picker && !picker.checked) picker.click();
    };

    const findForm = () => document.querySelector('[id*="easysell_cod_form_app_block"]');

    const moveForm = () => {
      if (!modal || !formSlot) return false;
      const formBlock = findForm();
      if (!formBlock) return false;
      if (!formSlot.contains(formBlock)) formSlot.appendChild(formBlock);
      const loading = formSlot.querySelector('[data-caseled-loading]');
      if (loading) loading.remove();
      if (observer) { observer.disconnect(); observer = null; }
      if (timer) { window.clearTimeout(timer); timer = null; }
      return true;
    };

    const waitForForm = () => {
      if (moveForm() || observer) return;
      observer = new MutationObserver(() => moveForm());
      observer.observe(document.body, { childList: true, subtree: true });
      timer = window.setTimeout(() => {
        if (observer) { observer.disconnect(); observer = null; }
        if (formSlot && !findForm()) {
          const loading = formSlot.querySelector('[data-caseled-loading]');
          if (loading) loading.textContent = 'الفورم ما بانش دابا. عاود جرّب من فضلك.';
        }
      }, 12000);
    };

    const openModal = (event) => {
      event.preventDefault();
      if (!modal) return;
      lastFocused = event.currentTarget;
      modal.hidden = false;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      updateLabelAndImage();
      waitForForm();
      if (modalPanel) modalPanel.focus();
    };

    const closeModal = () => {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.style.overflow = previousOverflow;
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-selected', active);
          candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        syncVariant(button);
        updateLabelAndImage();
      });
    });

    orderButtons.forEach((button) => button.addEventListener('click', openModal));

    if (modal) {
      modal.querySelectorAll('[data-caseled-close]').forEach((control) => control.addEventListener('click', closeModal));
      document.addEventListener('keydown', (event) => {
        if (modal.hidden) return;
        if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
        if (event.key === 'Tab' && modalPanel) {
          const focusables = Array.from(modalPanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null);
          if (!focusables.length) { event.preventDefault(); modalPanel.focus(); return; }
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
    }

    const currentVariant = document.querySelector('variant-picker input[data-variant-id]:checked');
    if (currentVariant) {
      const currentButton = buttons.find((button) => button.dataset.caseledVariantId === currentVariant.dataset.variantId);
      if (currentButton) {
        buttons.forEach((button) => {
          const active = button === currentButton;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
    }
    updateLabelAndImage();
  };

  const run = () => document.querySelectorAll('.caseled-landing').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
